import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TruncateText from './TruncateText';
import classNames from 'classnames';

import BookTitle from 'react/views/bookTitle/BookTitle';
import CatalogAnchor from 'react/views/catalogAnchor/CatalogAnchor';
import withLogFeatureUsage from 'react/containers/AnalyticContainer';
import {TitleBookJacket} from "react/views/bookJacket/BookJacket";
import OtsContainer from 'react/containers/OtsContainer';

import './titleView.less';

class Record extends Component {
	buildTitle(title, volumeNumber) {
		if (volumeNumber) {
			return `${volumeNumber} ${title}`;
		}

		return title;
	}

	renderAuthorName() {
		let author = null;

		if (this.props.title.author) {
			author = (
				<div title={this.props.title.author} className="record-title-authorname">
					<TruncateText line={1} truncateText="..." text={`${this.props.title.author}`} />
				</div>
			);
		}

		return author;
	}

	renderLexile() {
		if (this.props.title.lexile) {
			return(
				<div title={this.props.title.lexile} className="record-title-lexile">
					Lexile: {this.props.title.lexile}
				</div>
			);
		}
	}

	render() {
		let { hasTextPadding, otsEnabled, small, jacketClickEvent, titleClickEvent, otsFindItEvent, otsClickEvent, closeModal } = this.props;
		let { catalogLink, uniqueId, title, bookJacket, volumeNumber } = this.props.title;

		const TitleLink = withLogFeatureUsage(CatalogAnchor, jacketClickEvent, uniqueId);
		const imageClass = classNames('record-title-image', {small, ots: otsEnabled});

		return (
			<div className="record-title">
				<div className={imageClass}>
					<TitleLink onClick={() => closeModal()} catalogLink={catalogLink}>
						<TitleBookJacket image={bookJacket} title={title}  />
					</TitleLink>
				</div>
				<div className={classNames("record-title-text", {"record-title-text-padded": hasTextPadding})}>
					<div onClick={() => closeModal()}>
						<BookTitle title={title} small={true} catalogLink={catalogLink} featureType={titleClickEvent} uniqueId={uniqueId}>
							<TruncateText line={2} truncateText="..." text={this.buildTitle(title, volumeNumber)} />
						</BookTitle>
						{this.renderAuthorName()}
					</div>
					{this.renderLexile()}
					<OtsContainer item={this.props.title} otsEnabled={otsEnabled} otsFindItEvent={otsFindItEvent}
						otsClickEvent={otsClickEvent}
						loggingDestId={uniqueId} />
				</div>
			</div>
		);
	}
}

Record.propTypes = {
	jacketClickEvent: PropTypes.object.isRequired,
	titleClickEvent: PropTypes.object.isRequired,
	otsFindItEvent: PropTypes.object.isRequired,
	otsClickEvent: PropTypes.object.isRequired,
	hasTextPadding: PropTypes.bool,
	title: PropTypes.object.isRequired,
	small: PropTypes.bool,
	otsEnabled: PropTypes.bool,
	closeModal: PropTypes.func
}

export default Record;



// WEBPACK FOOTER //
// ./src/react/views/generic/TitleView.jsx